import React from 'react';
import { ID } from '../../../../types/typeDef';
import useStyle from './classeChoiceButton.style';
import { FlatIcon } from '../../Icons/FlatIcon';
interface ClasseChoiceButtonProps {
  id: ID;
  name: string;
  lycee: string;
  filiere: string;
  onClick: (id: ID) => void;
}

export const ClasseChoiceButton = ({
  id,
  name,
  lycee,
  filiere,
  onClick
}: ClasseChoiceButtonProps) => {
  const classes = useStyle();
  return (
    <div className={classes.container} onClick={() => onClick(id)}>
      <div className={classes.classContainer}>
        <p className={classes.name}>{name}</p>
        <div className={classes.infosContainer}>
          <div className={classes.iconTextContainer}>
            <FlatIcon icon={'Graduate'} size={'small'} color={'white'} />
            <p>{filiere}</p>
          </div>
          <div className={classes.iconTextContainer}>
            <FlatIcon icon={'College'} size={'small'} color={'white'} />
            <p>{lycee}</p>
          </div>
        </div>
      </div>
      <div className={classes.accessContainer}>
        <p>Accéder à cette classe</p>
        <FlatIcon icon={'RightArrow'} size={'normal'} color={'white'} />
      </div>
    </div>
  );
};
